<template>
  <div class="hero-actions fade-in-up delay-3">
    <a 
      v-if="primaryText"
      :href="primaryHref" 
      class="btn btn-primary-modern btn-lg" 
      @click.prevent="handleClick(primaryHref)"
    >
      <i v-if="primaryIcon" :class="primaryIcon"></i>
      <span>{{ primaryText }}</span>
      <div class="btn-glow-effect"></div>
    </a>
    <a 
      v-if="secondaryText"
      :href="secondaryHref" 
      class="btn btn-outline-modern btn-lg" 
      @click.prevent="handleClick(secondaryHref)"
    >
      <i v-if="secondaryIcon" :class="secondaryIcon"></i>
      <span>{{ secondaryText }}</span>
    </a>
  </div>
</template>

<script>
export default {
  name: 'HeroActions',
  props: {
    primaryText: {
      type: String,
      default: ''
    },
    primaryIcon: {
      type: String,
      default: ''
    },
    primaryHref: {
      type: String,
      default: '#'
    },
    secondaryText: {
      type: String,
      default: ''
    },
    secondaryIcon: {
      type: String,
      default: ''
    },
    secondaryHref: {
      type: String,
      default: '#'
    }
  },
  methods: {
    handleClick(href) {
      const element = document.querySelector(href)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/buttons";

.hero-actions {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;

  @media (max-width: 991px) {
    justify-content: center;
  }
}
</style>
